import { Component, OnInit, Input } from '@angular/core';
import { CommunicationsService } from 'libs/communications/components/src/lib/services/communications.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'tix-venue-communications',
  templateUrl: './venue-communications.component.html',
  styleUrls: ['./venue-communications.component.scss']
})
export class TixVenueCommunicationsComponent implements OnInit {
  @Input() venueId: string;

  @Input()
  canAdd?: boolean | null = true;
  @Input()
  canEdit?: boolean | null = true;
  @Input()
  canDelete?: boolean | null = true;

  templateArr: any[];
  isLoading = false;
  isBtnDisabled = false;

  setEmailTemplates(templateArr: any[]) {
    this.templateArr = templateArr;
  }

  enableBtn(value: boolean) {
    this.isBtnDisabled = !value;
  }

  isTemplateFormInValid() {
    if (!this.templateArr || this.templateArr.length == 0) {
      return false;
    }
    return this.templateArr
      .map(item => {
        return item.formGroup.invalid;
      })
      .includes(true);
  }

  isTemplateFormPristine() {
    if (!this.templateArr || this.templateArr.length == 0) {
      return false;
    }
    return !this.templateArr
      ?.map(item => {
        return item.formGroup.pristine;
      })
      .includes(false);
  }

  constructor(
    private communicationService: CommunicationsService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.enableBtn(false);
  }

  get formInvalid() {
    return this.isTemplateFormPristine() || this.isTemplateFormInValid();
  }

  setTemplateFormAsUntouched() {
    this.templateArr?.map(item => {
      item.formGroup.pristine = true;
    });
  }

  async saveTemplates() {
    this.isLoading = true;
    await this.communicationService.deleteVenueEmail(this.venueId);
    await this.communicationService
      .insertVenueEmail(
        this.templateArr.map(item => {
          return {
            venueId: this.venueId,
            emailContentId: item.formGroup.controls['templateName'].value
          };
        })
      )
      .then(res => {
        this.isLoading = false;
        this.snackBar.open('Template Updated successfully');
      })
      .catch(err => {
        console.log('err', err);
        this.isLoading = false;
        this.snackBar.open('Oops ! something went wrong');
      });
    this.setTemplateFormAsUntouched();
    this.enableBtn(false);
  }
}
